import * as t from "io-ts"

// const Statuses = t.record(t.string, t.number)

const StatusCount = t.record(t.string, t.number)

const DataByDay = t.record(t.string, StatusCount)

const DataByMonth = t.record(t.string, StatusCount)

const DataByYear = t.record(t.string, StatusCount)

const AdditionalData = t.type({
    responseTime30DayAvg: t.number,
    installedCapacity30DayAvg: t.number,
    demand30DayAvg: t.number,
    totOpenEscalations: t.number,
    totApplications: t.number,
    totLiveAlerts: t.number,
    totAutoApprovalRate: t.string,
    totCxAccepted: t.number,
})

const Device = t.type({
    type: t.string,
    systemReference: t.string,
    status: t.string,
    dataset: t.string,
})

const DeviceAlert = t.type({
    raisedAt: t.string,
    deviceSystemRef: t.string,
    description: t.string,
    alerterUsername: t.string,
    dataset: t.string,
})

export const DnoData = t.intersection([
    t.type({
        totLctsByDay: DataByDay,
        totLctsByMonth: DataByMonth,
        totLctsByYear: DataByYear,
    }),
    t.type({
        totLctsByResolvedStatus: t.record(
            t.string,
            t.record(t.string, t.number)
        ),
    }),
    AdditionalData,
    t.type({ topCompliantSummary: t.array(Device) }),
    t.type({ topLiveAlerts: t.array(DeviceAlert) }),
])

export type IDnoData = t.TypeOf<typeof DnoData>
